import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { filter, first, mapTo } from 'rxjs/operators';
import { BcConfigService } from 'common/config/provider';
import { GenesysUserPermissionService } from 'common/store/genesys-cloud/users/services/user-permission.service';
import { GenesysCloudMessageConversationsModulePermissions } from '../initialize-module.permissions';
import { initializeModule } from '../actions/message-conversation.actions';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudMessageConversationsInitializeModuleEffects {
  readonly initializeModule$ = createEffect(() => this.userPermissionService.hasAnyPermission$(
    ...GenesysCloudMessageConversationsModulePermissions
  ).pipe(
    filter(Boolean),
    filter(() => this.configService.isGenesysMessageConversationEnabled()),
    first(),
    mapTo(initializeModule())
  ));

  constructor(private readonly configService: BcConfigService,
              private readonly userPermissionService: GenesysUserPermissionService) {
  }
}
